import BrandIdentity from '@Guidelines/Component/Brand/BrandIdentity';
import useDisplayedLogo from '@Guidelines/Shell/AppShell/Hooks/useDisplayedLogo';
import useNavigationDrawer from '@Guidelines/Shell/AppShell/Hooks/useNavigationDrawer';
import NavigationMenu from '@Guidelines/Shell/AppShell/Menu/NavigationMenu/NavigationMenu';
import * as React from 'react';
import { Sidebar } from '@verclam/ui-kit';
import type { SidebarStyle } from '@verclam/ui-kit';

export const NAVIGATION_DRAWER_ID = 'navigation-drawer';

/** Overrides the kit's full-width rule for narrow viewports: the panel leaves a strip of page visible. */
const drawerStyle: SidebarStyle = {
	'--ui-kit-sidebar-width': 'min(20rem, 85vw)',
};

const contentStyle = { padding: '0.5rem 0.75rem 1.5rem' };

/**
 * The navigation menu below `layout.compactBreakpoint`: a left `Sidebar` driven by
 * `useNavigationDrawer`. It closes on every route change, whichever way the navigation happened.
 */
const NavigationDrawer: React.FC = () => {
	const { isOpen, close } = useNavigationDrawer();
	const logo = useDisplayedLogo();

	const passThrough = React.useMemo(() => ({ content: { style: contentStyle } }), []);

	return (
		<Sidebar
			id={NAVIGATION_DRAWER_ID}
			visible={isOpen}
			onHide={close}
			position="left"
			header={<BrandIdentity logo={logo} tone="light" size="compact" />}
			ariaCloseLabel="Fermer le menu"
			style={drawerStyle}
			pt={passThrough}
		>
			<NavigationMenu />
		</Sidebar>
	);
};

export default NavigationDrawer;
